module.exports = __webpack_public_path__ + "static/media/tire-depth-car.709860bb.svg";